import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import {
  isAuthenticated,
  registerStudent,
} from "../../../ApiService/ApiService";
import { isValidAadhar } from "../../../Utils/validFormDetails";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchClassesAsync,
  selectAllClasses,
  selectClassesLoading,
  selectClassesError,
} from "../../../Slices/classesSlice";
import ReactCardFlip from "react-card-flip";
import UpdateInfoRedirect from "./Info/UpdateInfoRedirect";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function RegisterStudent({ setShowRegisterStudent, fetchStudentsByClassId }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchClassesAsync());
  }, [dispatch]);

  const classes = useSelector(selectAllClasses);
  const classesLoading = useSelector(selectClassesLoading);
  const classesError = useSelector(selectClassesError);
  const schoolId = parseInt(sessionStorage.getItem("schoolId"));
  const [formData, setFormData] = useState({
    registrationId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    aadharNumber: "",
    dob: "",
    doj: "",
    gender: "",
    schoolId: schoolId,
    classId: "",
  });

  const [loading, setLoading] = useState(false);
  const [studentId, setStudentId] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "aadharNumber" && !/^\d*$/.test(value)) {
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.registrationId ||
      !formData.firstName ||
      !formData.lastName ||
      !formData.aadharNumber ||
      !formData.dob ||
      !formData.doj ||
      !formData.gender ||
      !formData.classId ||
      !formData.schoolId
    ) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill in all the required details.",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }
    if (!isValidAadhar(formData.aadharNumber)) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please enter a valid aadhar number.",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }
    setLoading(true);
    try {
      if (isAuthenticated()) {
        const response = await registerStudent(formData);
        // console.log("RES", response?.data);
        if (response) {
          if (response?.data?.status === 200) {
            setDialog({
              visible: true,
              title: "Success",
              message: "Registration successful",
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
            setStudentId(response?.data?.data?.studentId);
            fetchStudentsByClassId(formData?.classId);
            setFormData({
              registrationId: "",
              firstName: "",
              middleName: "",
              lastName: "",
              aadharNumber: "",
              dob: "",
              doj: "",
              gender: "",
              schoolId: schoolId,
              classId: "",
            });
            setIsFlipped(true);
          } else {
            const errorMessage =
              response?.data?.errorMessage || "Something went wrong";
            setDialog({
              visible: true,
              title: "Error",
              message: errorMessage,
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
          }
        } else {
          setDialog({
            visible: true,
            title: "Error",
            message: "Invalid response from the server",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Unauthorized action",
          message: "Please login and try again",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Something went wrong",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
        {/* Front  */}
        <Box sx={{ maxWidth: "75%", margin: "auto", padding: 3 }}>
          <Paper elevation={3} sx={{ padding: 5 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, fontSize: 22, color: "black" }}
            >
              Register Student
            </Typography>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    fullWidth
                    label="Registration Id"
                    name="registrationId"
                    value={formData.registrationId}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <TextField
                    fullWidth
                    label="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <TextField
                    fullWidth
                    label="Middle Name"
                    name="middleName"
                    value={formData.middleName}
                    onChange={handleChange}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Aadhar No."
                    name="aadharNumber"
                    value={formData.aadharNumber}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    select
                    fullWidth
                    label="Gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    size="small"
                    required
                  >
                    <MenuItem value={1}>Male</MenuItem>
                    <MenuItem value={2}>Female</MenuItem>
                    <MenuItem value={3}>Other</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <FormControl fullWidth required size="small">
                    <InputLabel id="class">Class</InputLabel>
                    <Select
                      name="classId"
                      label="Class"
                      labelId="class"
                      value={formData.classId}
                      onChange={handleChange}
                      size="small"
                      disabled={classesLoading || classesError}
                    >
                      {classesLoading ? (
                        <MenuItem value="">Loading...</MenuItem>
                      ) : classesError ? (
                        <MenuItem value="">Error fetching classes</MenuItem>
                      ) : (
                        classes?.data?.map((classItem) => (
                          <MenuItem key={classItem.id} value={classItem.id}>
                            {classItem.grade} - {classItem.section}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography sx={{ fontSize: 14, mb: 1, ml: 1 }}>
                    Date of Birth *
                  </Typography>
                  <TextField
                    fullWidth
                    name="dob"
                    type="date"
                    labelid="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography sx={{ fontSize: 14, mb: 1, ml: 1 }}>
                    Date of Joining *
                  </Typography>
                  <TextField
                    fullWidth
                    name="doj"
                    type="date"
                    labelid="doj"
                    value={formData.doj}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {" "}
                  <Button
                    fullWidth
                    variant="contained"
                    color="inherit"
                    onClick={() => setShowRegisterStudent(false)}
                    startIcon={<ArrowBack />}
                    sx={{ textTransform: "unset" }}
                  >
                    Back
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {" "}
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    endIcon={<ArrowForward />}
                    sx={{ textTransform: "unset" }}
                  >
                    {loading ? "Loading..." : "Submit"}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Box>

        {/* Back */}
        <UpdateInfoRedirect
          studentId={studentId}
          setShowRegisterStudent={setShowRegisterStudent}
        />
      </ReactCardFlip>
    </>
  );
}

export default RegisterStudent;
